// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.stack-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.stack-section-title mat-icon {
  color: #1976d2;
  /* azul Material */
}

.nbiot-icon {
  color: #388e3c !important;
  /* o el verde exacto que quieras */
  font-size: 22px !important;
}

.bluetooth-icon {
  font-size: 22px !important;
}

.title-label {
  font-weight: 600;
}

.title {
  padding: 5px;
  letter-spacing: 0.15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 1em;
  font-family: "DM Sans";
}

.icon {
  background-color: #dadadb;
  font-size: 21px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  padding: 13px;
  margin-right: 10px;
  color: #333;
}

.gray {
  font-size: 14px;
  color: var(--ion-color-medium);
  letter-spacing: 0.1px;
}

.highlight ion-input {
  font-weight: 600;
}

.section-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 50%;
  margin-right: auto;
}

.info-note {
  display: block;
  /* ← Cambio clave */
  background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  padding: 12px 16px;
  font-size: 14px;
  color: #5f5f5f;
  margin-bottom: 20px;
  border-radius: 4px;
}
.info-note mat-icon {
  vertical-align: middle;
  margin-right: 8px;
  color: #ffc107;
}
.info-note strong {
  color: #333;
  font-weight: 600;
}

.align-end {
  display: flex;
  justify-content: flex-end;
}

.orange-text {
  color: #ff7500;
}

.connectivity-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.connectivity-badge.bluetooth {
  background-color: #e3f2fd;
  color: #1976d2;
}

.connectivity-badge.nbiot {
  background-color: #e8f5e9;
  color: #388e3c;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/stack-settings/stack-settings.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAEF;;AACA;EACE,cAAA;EACA,kBAAA;AAEF;;AACA;EACE,yBAAA;EACA,kCAAA;EACA,0BAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AAEA;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;EACA,8BAAA;EACA,qBAAA;AACF;;AAGE;EACE,gBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,mBAAA;EAEA,UAAA;EAEA,kBAAA;AAHF;;AAQA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AALF;AAOE;EACE,sBAAA;EACA,iBAAA;EACA,cAAA;AALJ;AAQE;EACE,WAAA;EACA,gBAAA;AANJ;;AAWA;EACE,aAAA;EACA,yBAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,yBAAA;EACA,cAAA;AATF;;AAaA;EACE,yBAAA;EACA,cAAA;AAVF","sourcesContent":[".stack-section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\n.stack-section-title mat-icon {\n  color: #1976d2;\n  /* azul Material */\n}\n\n.nbiot-icon {\n  color: #388e3c !important;\n  /* o el verde exacto que quieras */\n  font-size: 22px !important;\n}\n\n.bluetooth-icon {\n  font-size: 22px !important;\n}\n\n.title-label {\n  font-weight: 600;\n}\n\n\n.title {\n  padding: 5px;\n  letter-spacing: 0.15px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  font-size: 1em;\n  font-family: \"DM Sans\";\n}\n\n.icon {\n  background-color: #dadadb;\n  font-size: 21px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 15px;\n  padding: 13px;\n  margin-right: 10px;\n  color: #333;\n}\n\n.gray {\n  font-size: 14px;\n  color: var(--ion-color-medium);\n  letter-spacing: 0.1px;\n}\n\n.highlight {\n  ion-input {\n    font-weight: 600;\n  }\n}\n\n.section-divider {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  //que sea hasta la mitad de la pantalla la liena del x 0 hasta y mitad patnalla\n  width: 50%;\n  //que este a la izquierda\n  margin-right: auto;\n}\n\n\n\n.info-note {\n  display: block;\n  /* ← Cambio clave */\n  background-color: #fff8e1;\n  border-left: 4px solid #ffc107;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #5f5f5f;\n  margin-bottom: 20px;\n  border-radius: 4px;\n\n  mat-icon {\n    vertical-align: middle;\n    margin-right: 8px;\n    color: #ffc107;\n  }\n\n  strong {\n    color: #333;\n    font-weight: 600;\n  }\n}\n\n\n.align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.orange-text {\n  color: #ff7500;\n}\n\n\n.connectivity-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.connectivity-badge.bluetooth {\n  background-color: #e3f2fd;\n  color: #1976d2;\n\n}\n\n.connectivity-badge.nbiot {\n  background-color: #e8f5e9;\n  color: #388e3c;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
